import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import type { FC, ReactNode } from 'react';
import { EDR_COLORS, edrCardSx } from './edrTokens';

type EdrKpiCardProps = {
  label: string;
  value: ReactNode;
  icon: ReactNode;
  iconColor?: string;
  accent?: string;
  children?: ReactNode;
};

export const EdrKpiCard: FC<EdrKpiCardProps> = ({
  label,
  value,
  icon,
  iconColor = EDR_COLORS.brand500,
  accent,
  children,
}) => (
  <Card sx={{ ...edrCardSx, flex: 1, minWidth: 0 }}>
    <CardContent style={{ padding: '16px 18px' }}>
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box minWidth={0}>
          <Typography
            style={{
              fontSize: 10,
              fontWeight: 600,
              letterSpacing: '0.4px',
              textTransform: 'uppercase',
              color: EDR_COLORS.textMuted,
              marginBottom: 10,
            }}
          >
            {label}
          </Typography>
          <Box
            style={{
              fontSize: 26,
              fontWeight: 700,
              lineHeight: 1.1,
              color: accent ?? EDR_COLORS.textPrimary,
              marginBottom: 8,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              flexWrap: 'wrap',
            }}
          >
            {value}
          </Box>
          {children ? (
            <Box
              style={{
                fontSize: 11,
                color: EDR_COLORS.textSecondary,
                display: 'flex',
                gap: 6,
                flexWrap: 'wrap',
                alignItems: 'center',
              }}
            >
              {children}
            </Box>
          ) : null}
        </Box>
        <Box
          style={{
            width: 34,
            height: 34,
            borderRadius: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: EDR_COLORS.brand50,
            color: iconColor,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);
